const SYMBOLS = 'º ° ª | @ # ! " · $ % & / \\ ( ) = ? ¿ ¡ [ ] { } < > , ; . : - _ ç Ç \' ´ ` * - + – “ ” ~ ¬ « »';
const ACCENTS = 'Á É Í Ó Ú á é í ó ú Ä Ë Ï Ö Ü ä ë ï ö ü À È Ì Ò Ù à è ì ò ù Â Ê Î Ô Û â ê î ô û ñ Ñ ã Ã õ';
const MATH_CHARS = 'Σ β ß η θ Θ δ Δ φ Φ ω Ω τ σ Σ π Π ε α Ø';

export const MAX_TRANSLATION_LENGTH = 60;

const ALLOWED = `${SYMBOLS}${ACCENTS}${MATH_CHARS}`;
const VALID_CHARS = new RegExp(
  `^[a-zA-Z0-9${ALLOWED.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}]*$`
);

/**
 * Motivos de invalidez. Aquí no se redacta el aviso: el texto se compone al
 * pintar, que es donde hay acceso a `lang.handle`.
 */
export const INVALID = {
  TOO_LONG: 'TOO_LONG',
  CHARS: 'CHARS',
  EMPTY_DEFAULT: 'EMPTY_DEFAULT',
};

/** Reglas comunes a cualquier traducción, una vez descartado el caso vacío. */
function validateContent(input) {
  if (input.length > MAX_TRANSLATION_LENGTH) {
    return { isValid: false, reason: INVALID.TOO_LONG, params: { max: MAX_TRANSLATION_LENGTH } };
  }
  if (!VALID_CHARS.test(input)) {
    return { isValid: false, reason: INVALID.CHARS };
  }
  return { isValid: true };
}

/** Traducción a un idioma cualquiera: vacía es válida (aún no traducida). */
export function validateTranslate(input = '') {
  if (input.length === 0) return { isValid: true };
  return validateContent(input);
}

/** Traducción en el idioma por defecto: vacía NO es válida, es el origen. */
export function validateTranslateDefaultLanguage(input = '') {
  if (input.length === 0) return { isValid: false, reason: INVALID.EMPTY_DEFAULT };
  return validateContent(input);
}
